import { ChangeDetectionStrategy, Component, inject, input, output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Router, RouterModule } from "@angular/router";

@Component({
  selector: "ui-event-card",
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <div class="event-box" [class.past]="isPast()" [class.is-registered]="isRegistered()" (click)="clickable() ? navigateTo(isRegistered() ? link() : (!isPast() && canRegister() ? registerLink() : (externalLink() || link())), $event) : null" [style.cursor]="clickable() ? 'pointer' : 'default'">
      <div class="image">
        <img [src]="image()" [alt]="name()">
      </div>

      <div class="info">
        @if (showLabel()) {
          <div class="label fs-14">{{ label() }}</div>
        }
        <div class="title it-title-sm">
          {{ name() }} {{ year() }}
  @if (isRegistered() && !isPast()) {
    <div class="status-badges d-flex flex-wrap gap-2">
      @if (confirmedParticipants() > 0 || confirmedSupporters() > 0) {
        <span class="badge bg-success d-flex align-items-center gap-1">
          <i class="bi bi-check-circle"></i>
          @if (confirmedParticipants() > 0) {
            <span class="d-flex align-items-center gap-1">
              {{ confirmedParticipants() }} <i class="bi bi-person"></i>
            </span>
          }
          @if (confirmedSupporters() > 0) {
            <span class="d-flex align-items-center gap-1 ms-1">
              {{ confirmedSupporters() }} <i class="bi bi-megaphone"></i>
            </span>
          }
        </span>
      }
      @if (pendingParticipants() > 0 || pendingSupporters() > 0) {
        <span class="badge bg-warning text-dark d-flex align-items-center gap-1">
          <i class="bi bi-clock"></i>
          @if (pendingParticipants() > 0) {
            <span class="d-flex align-items-center gap-1">
              {{ pendingParticipants() }} <i class="bi bi-person"></i>
            </span>
          }
          @if (pendingSupporters() > 0) {
            <span class="d-flex align-items-center gap-1 ms-1">
              {{ pendingSupporters() }} <i class="bi bi-megaphone"></i>
            </span>
          }
        </span>
      }
      @if (cancelledParticipants() > 0 || cancelledSupporters() > 0) {
        <span class="badge bg-danger d-flex align-items-center gap-1">
          <i class="bi bi-x-circle"></i>
          @if (cancelledParticipants() > 0) {
            <span class="d-flex align-items-center gap-1">
              {{ cancelledParticipants() }} <i class="bi bi-person"></i>
            </span>
          }
          @if (cancelledSupporters() > 0) {
            <span class="d-flex align-items-center gap-1 ms-1">
              {{ cancelledSupporters() }} <i class="bi bi-megaphone"></i>
            </span>
          }
        </span>
      }
      @if (confirmedParticipants() === 0 && confirmedSupporters() === 0 && pendingParticipants() === 0 && pendingSupporters() === 0 && cancelledParticipants() === 0 && cancelledSupporters() === 0) {
        <span class="status warning">
          @if (isUserParticipant()) {
            {{ status() || 'Plata în așteptare' }}
            @if (additionalParticipantsCount() > 0) {
              +{{ additionalParticipantsCount() }}
            }
          } @else {
            {{ additionalParticipantsCount() }} {{ additionalParticipantsCount() === 1 ? participantTitle().toLowerCase() + ' înscris' : participantTitlePlural().toLowerCase() + ' înscriși' }}
          }
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <g clip-path="url(#clip0_259_644)">
              <path d="M1.5625 5.625L3.75 7.8125L8.75 2.8125" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_259_644">
                <rect width="10" height="10" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </span>
      }
    </div>
  }
</div>

        <div class="info-cols">
          @if (!isPast() && (confirmedParticipants() > 0 || confirmedSupporters() > 0 || pendingParticipants() > 0 || pendingSupporters() > 0 || cancelledParticipants() > 0 || cancelledSupporters() > 0)) {
             <!-- Skip status column if we have detailed badges -->
          } @else if (status() || isRegistered()) {
            <div class="status-col">
              <div class="label fs-14">Status</div>
              <div class="value" [class.warning]="isRegistered() && !isPast()">{{ status() || 'Plata în așteptare' }}</div>
            </div>
          }
          @if (date()) {
            <div class="date-col">
              <div class="label fs-14">Data</div>
              <div class="value">{{ date() }}</div>
            </div>
          }
          @if (showLinkColumn()) {
            <div class="link-col">
              <div class="label fs-14">Pagină eveniment</div>
              <div class="value">
                @if (externalLink()) {
                  <a [href]="externalLink()" target="_blank" class="it-arrow-link" (click)="$event.stopPropagation()">
                    <span>Link</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                      <g clip-path="url(#clip0_259_624)">
                        <path d="M3.75 14L11.25 6.5" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.15625 6.5H11.25V12.5938" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_259_624">
                          <rect width="15" height="15" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                } @else {
                  <a [routerLink]="link()" class="it-arrow-link" (click)="$event.stopPropagation()">
                    <span>Link</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                      <g clip-path="url(#clip0_259_624)">
                        <path d="M3.75 14L11.25 6.5" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.15625 6.5H11.25V12.5938" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_259_624">
                          <rect width="15" height="15" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                }
              </div>
            </div>

            @if (rulesLink()) {
              <div class="link-col">
                <div class="label fs-14">Regulament</div>
                <div class="value">
                  <a [href]="rulesLink()" target="_blank" class="it-arrow-link" (click)="$event.stopPropagation()">
                    <span>Link</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                      <g clip-path="url(#clip0_259_624)">
                        <path d="M3.75 14L11.25 6.5" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.15625 6.5H11.25V12.5938" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_259_624">
                          <rect width="15" height="15" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </div>
              </div>
            }
          }
        </div>
      </div>

      @if (showButtons()) {
        <div class="button">
          @if (isRegistered()) {
            <a [routerLink]="link()" class="btn btn-secondary" (click)="$event.stopPropagation()">Gestionează</a>
            @if (isCheckinOpen() && hasDownloadableTickets()) {
              <button type="button" class="btn btn-outline-secondary" [disabled]="ticketsLoading()" (click)="$event.stopPropagation(); ticketsClick.emit()">
                {{ ticketsLoading() ? 'Se descarcă…' : 'Bilete' }}
              </button>
            }
          } @else if (!isPast() && canRegister()) {
            <a [routerLink]="registerLink()" class="btn btn-primary" (click)="$event.stopPropagation()">Mă înscriu</a>
          } @else if (externalLink()) {
            <a [href]="externalLink()" target="_blank" class="btn btn-secondary" (click)="$event.stopPropagation()">Detalii</a>
          } @else {
            <a [routerLink]="link()" class="btn btn-secondary" (click)="$event.stopPropagation()">Detalii</a>
          }
        </div>
      }
    </div>
    @if (pricingSummary(); as ps) {
      <div class="pricing-bar">
        @if (ps.participants) {
          @if (ps.participants.remaining_seats !== null) {
            <span>{{ ps.participants.remaining_seats }} locuri de la {{ ps.participants.price }} RON</span>
          } @else {
            <span>de la {{ ps.participants.price }} RON</span>
          }
        }
        @if (ps.supporters) {
          <span> · susținători de la {{ ps.supporters.price }} RON ({{ ps.supporters.remaining_seats }} locuri)</span>
        }
      </div>
    }
  `,
  styleUrl: "./ui-event-card.css",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiEventCardComponent {
  private readonly router = inject(Router);

  name = input.required<string>();
  year = input.required<string>();
  date = input<string | null>();
  location = input<string>();
  image = input<string | null | undefined, string | null | undefined>("assets/img/event-placeholder.png", {
    transform: (value: string | null | undefined): string | null | undefined => value || "assets/img/event-placeholder.png"
  });
  isPast = input<boolean>(false);
  isRegistered = input<boolean>(false);
  isUserParticipant = input<boolean>(false);
  additionalParticipantsCount = input<number>(0);
  status = input<string | null>(null);
  link = input<string | any[]>([]);
  externalLink = input<string | null>(null);
  rulesLink = input<string | null>(null);
  registerLink = input<string | any[]>([]);
  canRegister = input<boolean>(true);
  participantTitle = input<string>("Participant");
  participantTitlePlural = input<string>("Participanți");
  confirmedParticipants = input<number>(0);
  confirmedSupporters = input<number>(0);
  pendingParticipants = input<number>(0);
  pendingSupporters = input<number>(0);
  cancelledParticipants = input<number>(0);
  cancelledSupporters = input<number>(0);
  showButtons = input<boolean>(true);
  isCheckinOpen = input<boolean>(false);
  // #830: the "Bilete" button must reflect a real ticket, never a merely
  // PAYMENT_INITIATED order. #418 r2: the ticket is issued only once check-in
  // is FINALIZED, and the combined download is all-or-nothing over the group —
  // hence "downloadable", decided by the caller, not merely "confirmed".
  hasDownloadableTickets = input<boolean>(false);
  ticketsLoading = input<boolean>(false);
  ticketsClick = output<void>();
  showLinkColumn = input<boolean>(true);
  showLabel = input<boolean>(true);
  label = input<string>("Eveniment");
  clickable = input<boolean>(true);
  pricingSummary = input<{ participants?: { price: number; remaining_seats: number | null }; supporters?: { price: number; remaining_seats: number } } | null>(null);

  navigateTo(l: string | any[], event: Event) {
    if (typeof l === "string" && (l.startsWith("http://") || l.startsWith("https://"))) {
      window.open(l, "_blank");
      return;
    }
    if (Array.isArray(l)) {
      this.router.navigate(l);
    } else {
      this.router.navigateByUrl(l);
    }
  }
}
